var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-success",on:{"click":function($event){$event.preventDefault();return _vm.handleShowModal.apply(null, arguments)}}},[_vm._v(" Notes ")])
}
var staticRenderFns = []

export { render, staticRenderFns }